
    import _transform from '/Users/asko/Git/svg.rx.js/demo/pages/transform.svelte'
import __layout from '/Users/asko/Git/svg.rx.js/demo/pages/_layout.svelte'
import _index from '/Users/asko/Git/svg.rx.js/demo/pages/index.svelte'
import _circles from '/Users/asko/Git/svg.rx.js/demo/pages/circles.svelte'


 export const routes = [
{
  "isFallback": false,
  "path": "/transform",
  "regex": "^/transform",
  "name": "/transform",
  "ranking": "ZZ",
  "url": "/transform",
  "component": () => _transform,
  "layouts": [
    () => __layout
  ]
},
{
  "isFallback": false,
  "path": "/index",
  "regex": "^/index",
  "name": "/index",
  "ranking": "ZZ",
  "url": "/index",
  "component": () => _index,
  "layouts": [
    () => __layout
  ]
},
{
  "isFallback": false,
  "path": "/circles",
  "regex": "^/circles",
  "name": "/circles",
  "ranking": "ZZ",
  "url": "/circles",
  "component": () => _circles,
  "layouts": [
    () => __layout
  ]
}
]

    export const options = {"unknownPropWarnings":false}
    